import React, { useState } from "react";
import { Grid, TextField } from "@mui/material";

interface ISetupFormProps {
  tenantIdValue: string;
  deviceNameValue: string;
  placeholderUrlValue: string;
  setTenantIdValue: (value: string) => void;
  setDeviceNameValue: (value: string) => void;
  setPlaceholderUrlValue: (value: string) => void;
}

const SetupForm: React.FC<ISetupFormProps> = ({
  tenantIdValue,
  deviceNameValue,
  placeholderUrlValue,
  setTenantIdValue,
  setDeviceNameValue,
  setPlaceholderUrlValue
}) => {
  const [localTenantId, setLocalTenantId] = useState(tenantIdValue);
  const [localDeviceName, setLocalDeviceName] = useState(deviceNameValue);
  const [localPlaceholderUrl, setLocalPlaceholderUrl] = useState(placeholderUrlValue);
/*   const [isValidPlaceholder, setIsValidUrl] = useState(true);
  
  useEffect(() => {
    if (localPlaceholderUrl) {
      setIsValidUrl(isValidUrl(placeholderUrlValue));
    }
  }, [localPlaceholderUrl]);
 */
  return (
    <form autoComplete="off" autoCorrect="off" style={{ width: "100%" }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            name="tenantId"
            label="Tenant Id"
            fullWidth
            margin="normal"
            value={localTenantId}
            onChange={(e) => setLocalTenantId(e.target.value)}
            onBlur={() => setTenantIdValue(localTenantId)}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            name="deviceName"
            label="Gerätename"
            fullWidth
            margin="normal"
            value={localDeviceName}
            onChange={(e) => setLocalDeviceName(e.target.value)}
            onBlur={() => setDeviceNameValue(localDeviceName)}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            name="placeholderUrl"
            label="Platzhalter-URL"
            fullWidth
            margin="normal"
            helperText="Bleibt dieses Feld leer wird am Display ein Hinweisbildschirm angezeigt wenn es nicht verwendet wird. Alternativ können Sie hier gerne eine eigene Werbe-Website oder ein Werbe-Bild anzeigen. Die angegebene Website sollte keine Cookies speichern und benötigt somit auch kein Cookie Popup."
            value={localPlaceholderUrl}
           /*  onChange={(e) => setLocalPlaceholderUrl(e.target.value)}
            onBlur={() => isValidPlaceholder && setPlaceholderUrlValue(localPlaceholderUrl)}
            error={!isValidPlaceholder} */
            onChange={(e) => setLocalPlaceholderUrl(e.target.value)}
            onBlur={() => setPlaceholderUrlValue(localPlaceholderUrl)}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default SetupForm;
